import { APP_NAME } from './brand/brandInfo';
import { nestLogo, nestLogoWithName } from './brand/brandLogos';

export const APP_CONSTANTS = {
  APP_NAME,
  APP_URL: 'https://nest.emmple.com',
  APP_DESCRIPTION: 'School Management System',
  ASSETS: {
    logo: nestLogo,
    logoWithName: nestLogoWithName,
    emmpleLogo: '/images/emmple-logo.svg',
  },
} as const;

export type AppConstants = typeof APP_CONSTANTS;


